$eve_app_page_components_empty $eve_app_page_sb_page
	title \Empty
	Head null
	body /
		<= Overview_page $eve_app_page_sb_page
			title null
			body /
				<= Playground $eve_app_page_sb_playground
					component_name \Live_empty
					default_source \
						\Live_empty $eve_empty
						\	title \No items
						\	description /
						\		\Try adjusting filters or add new data.
						\	action /
						\		<= Retry $eve_button
						\			label \Refresh
						\			colors \primary
						\			variant \outline
						\
